(function () {
  if (window.__tmgRecentlyViewedInit) return;
  window.__tmgRecentlyViewedInit = true;

  var MAX_ITEMS = 30;
  var MAX_AGE = 30 * 24 * 60 * 60;
  var REQUEST_TIMEOUT = 15000;

  function getStorage(name) {
    try {
      return window[name];
    } catch (error) {
      return null;
    }
  }

  function readStoredJson(storage, key, fallback) {
    if (!storage) return fallback;

    try {
      var value = storage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeStoredJson(storage, key, value) {
    if (!storage) return;

    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function removeStoredItem(storage, key) {
    if (!storage) return;

    try {
      storage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  function sameCardSettings(cached, current) {
    if (!cached || !current || typeof cached !== 'object' || typeof current !== 'object') {
      return false;
    }

    var cachedKeys = Object.keys(cached).sort();
    var currentKeys = Object.keys(current).sort();
    if (cachedKeys.length !== currentKeys.length) return false;

    return cachedKeys.every(function (key, index) {
      return key === currentKeys[index] && cached[key] === current[key];
    });
  }

  function cardFromMarkup(markup) {
    if (typeof markup !== 'string') return null;

    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    return parsed.querySelector('.productgrid--item');
  }

  function fetchMarkup(url) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var options = { credentials: 'same-origin' };
    var timeout;

    if (controller) options.signal = controller.signal;

    var request = fetch(url, options)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .catch(function () {
        return '';
      });

    var deadline = new Promise(function (resolve) {
      timeout = window.setTimeout(function () {
        if (controller) controller.abort();
        resolve('');
      }, REQUEST_TIMEOUT);
    });

    return Promise.race([request, deadline]).then(function (markup) {
      window.clearTimeout(timeout);
      return markup;
    });
  }

  function initSection(dataElement) {
    if (!dataElement || dataElement.dataset.recentlyViewedReady === 'true') return;
    dataElement.dataset.recentlyViewedReady = 'true';

    var sectionRoot = dataElement.closest('.shopify-section') || dataElement.parentElement;
    var section = sectionRoot && sectionRoot.querySelector('[data-recently-viewed-section]');
    var container = section && section.querySelector('[data-recently-viewed-container]');
    var clearButton = section && section.querySelector('[data-clear-recently-viewed]');

    if (!section || !container) return;

    var data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    var routes = data.routes || {};
    var currency = data.currency || '';
    var storageKey = 'pxu-recentlyViewed-' + currency + '-' + (routes.root_url || '/');
    var currentProduct = data.recently_viewed_info;
    var cardSettings = data.product_card_settings || {};
    var now = Math.floor(Date.now() / 1000);
    var oldestAllowed = now - MAX_AGE;
    var localStore = getStorage('localStorage');
    var sessionStore = getStorage('sessionStorage');
    var history = readStoredJson(localStore, storageKey, []);

    if (!Array.isArray(history)) history = [];

    history = history.filter(function (item) {
      return item && typeof item.handle === 'string' && item.handle &&
        typeof item.timestamp === 'number' && item.timestamp > oldestAllowed;
    });

    var currentHandle = currentProduct && typeof currentProduct.handle === 'string'
      ? currentProduct.handle
      : '';

    if (currentHandle) {
      history = history.filter(function (item) {
        return item.handle !== currentHandle;
      });
      history.push({ handle: currentHandle, timestamp: now });
    }

    if (history.length > MAX_ITEMS) {
      history = history.slice(history.length - MAX_ITEMS);
    }

    writeStoredJson(localStore, storageKey, history);

    // Stored so the next page can show it, but never rendered here: the shopper
    // is already on it, and it would take the only slot visible without scrolling.
    var displayHistory = history.filter(function (item) {
      return item.handle !== currentHandle;
    });

    var cards = readStoredJson(sessionStore, storageKey, {});
    if (!cards || typeof cards !== 'object' || Array.isArray(cards) ||
      !sameCardSettings(cards.cardSettings, cardSettings)) {
      cards = {};
    }
    cards.cardSettings = cardSettings;

    function hideSection() {
      container.textContent = '';
      section.hidden = true;
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        removeStoredItem(localStore, storageKey);
        removeStoredItem(sessionStore, storageKey);
        hideSection();
      });
    }

    if (!displayHistory.length || !routes.all_products_collection_url) {
      hideSection();
      return;
    }

    var collectionUrl = routes.all_products_collection_url.replace(/\/$/, '');
    var cardNodes = {};
    var requests = displayHistory.map(function (item) {
      var cachedCard = cardFromMarkup(cards[item.handle]);
      if (cachedCard) {
        cardNodes[item.handle] = cachedCard;
        return Promise.resolve();
      }

      delete cards[item.handle];

      var url = collectionUrl + '/products/' + encodeURIComponent(item.handle) + '?view=recently-viewed';
      return fetchMarkup(url)
        .then(function (markup) {
          var card = cardFromMarkup(markup);
          if (!card) return;

          cards[item.handle] = markup;
          cardNodes[item.handle] = card;
        });
    });

    Promise.all(requests).then(function () {
      if (!section.isConnected) return;

      writeStoredJson(sessionStore, storageKey, cards);

      var fragment = document.createDocumentFragment();
      displayHistory.slice().reverse().forEach(function (item) {
        var card = cardNodes[item.handle];
        if (card) fragment.appendChild(document.importNode(card, true));
      });

      container.textContent = '';
      container.appendChild(fragment);
      section.hidden = container.children.length === 0;

      if (!section.hidden && typeof window.tmgInitCollectionSwipers === 'function') {
        window.tmgInitCollectionSwipers();
      }
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-section-type="static-recently-viewed"][data-section-data]'),
      initSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
